import { useCallback } from 'react';
import { getProperty } from 'customer-data-objects/record/ObjectRecordAccessors';
export function useGetAdditionalPropertyValue(subject) {
  return useCallback(propertyName => getProperty(subject, propertyName), [subject]);
}